import RedisApiAxiosInstance from 'services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { Config } from '../../config';

const initContextEngineMFEApiService = async () => {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const initApiService = await import('contextengine/initApiService');

    initApiService.default(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.SM
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('cannot load initContextEngineMFEApiService', e);
  }
};

export default initContextEngineMFEApiService;
